export default {
     getUser(state){
        return state.user
     },
}


// WEBPACK FOOTER //
// ./src/vuex/user/getter.js